import {ResolveFn} from '@angular/router';
import {Dataset} from '../api/fit-api/models/datasets/dataset';
import {inject} from '@angular/core';
import {DatasetService} from '../api/fit-api/dataset.service';

export const byDollarsDatasetsResolver: ResolveFn<Array<Dataset>> = () => {
	return resolveByDollarsDatasets();
};

export const resolveByDollarsDatasets = () => {
	const datasetService = inject(DatasetService);

	return datasetService.getDefaultFinancialsDatasets();
};
